module.exports = __webpack_public_path__ + "static/media/ne.a7f07f0c.svg";